import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'mj-user-job',
  templateUrl: './userjob.component.html',
  styleUrls: ['./userjob.component.scss'],
})
export class UserJobComponent {
  constructor(private _route: ActivatedRoute) {
    // Retrieves the ID from the route parameters
    this._route.params.subscribe(params => {
      const jobId = params['id'];
      window.location.href = 'https://job.mojob.io/' + jobId;
    });
  }
}
